import { Navigate, useLocation } from 'react-router-dom';

/** Legacy destinations keep dates, year, account and safe return parameters. */
export default function AccountingRedirect({ to, dropParams = [] }) {
  const { search } = useLocation();
  const [pathname, query = ''] = to.split('?');
  const params = new URLSearchParams(search);
  for (const key of dropParams) params.delete(key);
  for (const [key, value] of new URLSearchParams(query)) params.set(key, value);
  return <Navigate to={`${pathname}${params.size ? `?${params}` : ''}`} replace />;
}
